import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar,
} from '@mui/material';

import {
    CheckCircleOutline,
    HomeOutlined,
    MeetingRoomOutlined,
    VolumeMuteOutlined,
    VisibilityOffOutlined,
    LockOutlined,
    PeopleAltOutlined,
    AccessTimeOutlined,
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    fontSize: '1.1rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1
                                }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアでプライバシーを確保する意義
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    fontSize: '1.1rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1
                                }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('private-room')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    個室空間の快適化テクニック
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    fontSize: '1.1rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1
                                }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('sound-privacy')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    防音・目隠し対策の実践法
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    fontSize: '1.1rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1
                                }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('digital-privacy')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    デジタルプライバシーの守り方
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    fontSize: '1.1rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1
                                }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('distance-communication')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    心地よい距離感を保つコミュニケーション
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    fontSize: '1.1rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1
                                }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('private-time')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    一人時間の確保アイデア
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    fontSize: '1.1rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1
                                }}>
                                    7.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめと実践のポイント
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}
            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアでプライバシーを確保する意義
                </Typography>
                <Typography variant="body1" paragraph>
                    生活コストを抑えたり、交流の幅を広げたりと、さまざまな魅力があるルームシェア。しかし、他人同士が同じ屋根の下で暮らすからこそ「自分だけの空間」や「心の距離感」を上手に保つことが、快適な生活のカギとなります。
                </Typography>
                <Typography variant="body1" paragraph>
                    本記事では、個室空間の快適化、防音・目隠し・デジタルプライバシー対策、そしてルームメイトとのちょうど良い距離感や一人時間の確保法まで、すぐに使える実践テクニックをわかりやすくご紹介します。
                </Typography>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/roommate-living_roomshare-privacy-technique.jpg"
                        alt="明るい共有リビングで異なるライフスタイルを持つルームメイトがリラックスして過ごしている様子。ナチュラルな木目調の家具や観葉植物が配置され、温かみのある雰囲気を演出しながらも、各自が思い思いの時間を過ごしている"
                        width="100%"
                        style={{ borderRadius: 12, boxShadow: '0 2px 16px rgba(0,0,0,0.10)' }}
                    />
                </Box>
                <Divider sx={{ my: 2 }} />
            </Box>
            {/* 個室空間の快適化テクニック */}
            <Box id="private-room" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    個室空間の快適化テクニック
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <MeetingRoomOutlined sx={{ color: 'primary.main', mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>レイアウトの工夫</Typography>
                            </Box>
                            <Typography variant="body2">
                                ベッドやデスクなどの大きな家具は、出入口や窓を避けて配置し、部屋の奥に自分だけの「コーナー」を作るのがおすすめ。観葉植物やパーテーションを活用して、視線や生活動線をゆるやかに区切ることで、心理的な安心感が生まれます。
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <HomeOutlined sx={{ color: 'primary.main', mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>照明・色彩で“自分空間”を演出</Typography>
                            </Box>
                            <Typography variant="body2">
                                間接照明や温かみのある布小物で、自分らしいテイストに。白や明るいパステルカラーを基調にすると、個室がより広く感じられ、落ち着いた雰囲気に包まれます。
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3 }}>
                    <img
                        src="/images/blog/private-room-deco_roomshare-privacy-technique.jpg"
                        alt="シンプルで明るい個室に、間接照明と観葉植物、優しい色合いのファブリックが配置され、心地よくリラックスできる雰囲気を演出している。プライベートな時間を大切にできる工夫が随所に見られる"
                        width="100%"
                        style={{ borderRadius: 12, boxShadow: '0 2px 16px rgba(0,0,0,0.10)' }}
                    />
                </Box>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    <Chip label="POINT" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                    「自分だけの快適なゾーン」を意識してつくろう。
                </Typography>
                <Divider sx={{ my: 2 }} />
            </Box>
            {/* 防音・目隠し対策の実践法 */}
            <Box id="sound-privacy" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    防音・目隠し対策の実践法
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <VolumeMuteOutlined sx={{ color: 'primary.main', mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>簡単にできる防音アイデア</Typography>
                            </Box>
                            <List>
                                <ListItem sx={{ pl: 0 }}>
                                    <ListItemIcon>
                                        <CheckCircleOutline color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="厚手のカーテンやドアの隙間テープで音漏れ軽減"
                                        secondary="市販の防音シートやラグマットも効果的"
                                    />
                                </ListItem>
                                <ListItem sx={{ pl: 0 }}>
                                    <ListItemIcon>
                                        <CheckCircleOutline color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="BGMやホワイトノイズで生活音をカモフラージュ"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <VisibilityOffOutlined sx={{ color: 'primary.main', mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>目隠し・視線カットの工夫</Typography>
                            </Box>
                            <List>
                                <ListItem sx={{ pl: 0 }}>
                                    <ListItemIcon>
                                        <CheckCircleOutline color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="突っ張り棒＆カーテンで即席パーテーション"
                                    />
                                </ListItem>
                                <ListItem sx={{ pl: 0 }}>
                                    <ListItemIcon>
                                        <CheckCircleOutline color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="観葉植物やオープンラックで間仕切り"
                                        secondary="圧迫感が少なく、空間もおしゃれに"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3 }}>
                    
                </Box>
                <Divider sx={{ my: 2 }} />
            </Box>
            {/* デジタルプライバシーの守り方 */}
            <Box id="digital-privacy" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    デジタルプライバシーの守り方
                </Typography>
                <Paper elevation={0} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <LockOutlined sx={{ color: 'primary.main', mr: 1 }} />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>SNS・ネットワークの注意点</Typography>
                    </Box>
                    <List>
                        <ListItem sx={{ pl: 0 }}>
                            <ListItemIcon>
                                <CheckCircleOutline color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="Wi-Fiパスワードの管理を徹底"
                                secondary="共有Wi-Fiは定期的に変更し、外部には漏らさない"
                            />
                        </ListItem>
                        <ListItem sx={{ pl: 0 }}>
                            <ListItemIcon>
                                <CheckCircleOutline color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="PC・スマホは必ずロック＆個人データは共有端末で保存しない"
                            />
                        </ListItem>
                        <ListItem sx={{ pl: 0 }}>
                            <ListItemIcon>
                                <CheckCircleOutline color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="SNS投稿は居住情報やルームメイトのプライバシーに配慮"
                            />
                        </ListItem>
                    </List>
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        <Chip label="TIP" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                        デジタル面でも「情報の境界線」を作ることが大切です。
                    </Typography>
                </Paper>
                <Divider sx={{ my: 2 }} />
            </Box>
            {/* 心地よい距離感を保つコミュニケーション */}
            <Box id="distance-communication" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    心地よい距離感を保つコミュニケーション
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <PeopleAltOutlined sx={{ color: 'primary.main', mr: 1, verticalAlign: 'middle' }} />
                    <Typography variant="body1" component="span" sx={{ fontWeight: 600 }}>
                        ルール＋思いやり＝快適な人間関係
                    </Typography>
                </Box>
                <List>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon>
                            <CheckCircleOutline color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="「個室にいるときは基本そっとしておく」など暗黙のマナーを明文化"
                        />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon>
                            <CheckCircleOutline color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="チャットやメモで伝言、口頭での不用意な呼びかけを減らす"
                        />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon>
                            <CheckCircleOutline color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="家事や共有スペースの使い方も定期的に話し合い、ギスギス防止"
                        />
                    </ListItem>
                </List>
                <Box sx={{ mt: 2, pl: 1 }}>
                    <Typography variant="body2">
                        <Chip label="EXPERT ADVICE" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                        距離感は「話し合い」と「ちょっとした配慮」で大きく変わります。最初にルールを決め、変化があれば柔軟にアップデートを。
                    </Typography>
                </Box>
                <Box sx={{ mt: 3 }}>
                    
                </Box>
                <Divider sx={{ my: 2 }} />
            </Box>
            {/* 一人時間の確保アイデア */}
            <Box id="private-time" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    一人時間の確保アイデア
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <AccessTimeOutlined sx={{ color: 'primary.main', mr: 1 }} />
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>「ひとり」の質を高めるヒント</Typography>
                </Box>
                <List>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon>
                            <CheckCircleOutline color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="個室に“Do Not Disturb”サインを活用"
                            secondary="集中したい時やリラックスしたい時に有効"
                        />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon>
                            <CheckCircleOutline color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="リビングやバスルームの利用時間をシェアメンバー同士で調整"
                        />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon>
                            <CheckCircleOutline color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="外出やカフェなど、家以外での“ひとり時間”も活用"
                        />
                    </ListItem>
                </List>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    <Chip label="LIFESTYLE" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                    「一人時間」を意識的に取ることで、共同生活のストレスも軽減できます。
                </Typography>
                <Divider sx={{ my: 2 }} />
            </Box>
            {/* まとめと実践のポイント */}
            <Box id="summary" sx={{ mb: 2 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめと実践のポイント
                </Typography>
                <Paper elevation={2} sx={{ p: 3, borderRadius: 2, bgcolor: '#f5f5f5' }}>
                    <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                        ルームシェアの快適さは「物理的な工夫」と「心の距離感」を整えることで劇的に高まります。
                    </Typography>
                    <List>
                        <ListItem sx={{ pl: 0 }}>
                            <ListItemIcon>
                                <CheckCircleOutline color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="個室空間を快適に整え、プライバシーの境界線を明確に"
                            />
                        </ListItem>
                        <ListItem sx={{ pl: 0 }}>
                            <ListItemIcon>
                                <CheckCircleOutline color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="防音・目隠し・デジタル面も抜かりなく"
                            />
                        </ListItem>
                        <ListItem sx={{ pl: 0 }}>
                            <ListItemIcon>
                                <CheckCircleOutline color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="距離感や一人時間を大切に、ルームメイトとの信頼関係を築こう"
                            />
                        </ListItem>
                    </List>
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        どれも難しいテクニックではありません。小さな配慮や工夫の積み重ねで、ルームシェアはもっと自由で心地よい場所になります。ぜひ今日から取り入れてみてください。
                    </Typography>
                </Paper>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-privacy-technique',
    slug: 'roomshare-privacy-technique',
    title: 'ルームシェアでのプライバシー確保術：個室の快適化と心の距離感の保ち方',
    excerpt: '個室空間活用テク\n防音・目隠し対策\nデジタルプライバシー保護\n距離感のコミュニケーション\n一人時間の確保',
    coverImage: '/images/blog/cover-roomshare-privacy_roomshare-privacy-technique.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。温かみのある木目調インテリアと観葉植物に囲まれ、自然な距離感と快適な空気感が感じられる空間。',
    publishedAt: '2024-06-15T00:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', '暮らしの知恵', 'プライバシー'],
    tags: ['個室アレンジ', '防音対策', 'シェアハウス', 'デジタルプライバシー', 'コミュニケーション'],
    author: {
        name: '高橋未来',
        avatar: '/images/avatars/mirai-takahashi.jpg',
        bio: 'ルームシェア歴10年、シェア物件アドバイザー。多数の住まいでの実体験をもとに、快適な共同生活のノウハウや空間づくりのコツを発信中。趣味は間取り図鑑賞とDIY。',
        profilePicture: '/images/avatars/mirai-takahashi.jpg'
    },
    viewCount: 1270,
    contentComponent: PostContent
};

export default post;